import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'legSelection',
})
export class LegSelectionPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    if (value === 'ita') {
      return 'II';
    } else if (value === 'trita') {
      return 'III';
    } else if (['pmu_tierce_standard', 'pmu_quarte_plus_standard'].includes(value)) {
      return 'K';
    } else {
      return 'I';
    }
  }
}
